/**
 * ``standardBody()`` — produces the three required base-body fields
 * every event carries (Plan_05 § "Standard body — mandatory on every
 * event"): ``app``, ``app_version``, ``ui_version``.
 *
 * Centralised so each capture call site spreads ``...standardBody()``
 * into its event payload rather than typing the trio by hand, and so
 * the source of truth for the constants is one file (not a grep).
 *
 * - ``app`` is the fixed brand string.
 * - ``app_version`` is the build-time git sha when the build step
 *   exposes ``NEXT_PUBLIC_APP_VERSION`` (a vercel / docker build can
 *   set this); falls back to ``"dev"`` for local development.
 * - ``ui_version`` is manually bumped per design refresh; today it is
 *   the pilot tag from Plan_05's pilot-go-live spec.
 *
 * Both ``app_version`` and ``ui_version`` are strings on the schema;
 * keep them strings here even when an operator hasn't set the env
 * — Plan_05 requires the property to exist, not to be a specific
 * shape beyond "string".
 */

export const APP_VERSION: string =
  process.env.NEXT_PUBLIC_APP_VERSION ?? "dev";

export const UI_VERSION = "v2-pilot-may-2026";

export function standardBody(): {
  app: "mi-platform";
  app_version: string;
  ui_version: string;
} {
  return {
    app: "mi-platform",
    app_version: APP_VERSION,
    ui_version: UI_VERSION,
  };
}
